import {typography} from 'material-ui/styles';

const styles = {
    grid: {
        paddingBottom: '20px'
    },
    rightIcon: {
        position: 'absolute',
        right: 10
    },
    dropzone: {
        container: {
            border: '1px dashed black',
            borderRadius: '10px',
            padding: '10px',
            marginLeft: '15px',
            marginRight: '15px',
            textAlign: 'center'
        },
        loading: {
            textAlign: 'left',
            marginBottom: '20px',
            fontSize: 16,
            fontWeight: typography.fontWeightLight,
        }
    },
    title: {
        fontSize: 18,
        fontWeight: typography.fontWeightNormal,
    },
    subtitle: {
        fontSize: 16,
        fontWeight: typography.fontWeightLight,
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/media/MediaBlocs/MediaBlocs.css.js